<template>
  <div>
    <h2>阅读</h2>

    <Divider>计划</Divider>

    <Table class="table" :columns="col1" :data="planData.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="article">
        <i-button type="primary" size="small" @click="editArticle(row)"
          >读后感</i-button
        >
      </template>
      <template slot-scope="{ row }" slot="comment">
        <i-button type="primary" size="small" @click="editComment(row)"
          >点评</i-button
        >
      </template>
      <template slot-scope="{ row }" slot="action">
        <i-button type="dashed" size="small" @click="edit(row)">修改</i-button>
        <i-button
          type="success"
          size="small"
          style="margin-left: 5px"
          @click="setHistory(row)"
          >设为历史</i-button
        >
      </template>
    </Table>

    <Button type="dashed" class="add-btn" @click="edit({})">添加</Button>

    <Divider>历史</Divider>
    <Table class="table" :columns="col1" :data="historyData.list">
      <template slot-scope="{ row }" slot="number">
        {{ row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="article">
        <i-button type="primary" size="small" @click="editArticle(row)"
          >读后感</i-button
        >
      </template>
      <template slot-scope="{ row }" slot="comment">
        <i-button type="primary" size="small" @click="editComment(row)"
          >点评</i-button
        >
      </template>
      <template slot-scope="{ row }" slot="action">
        <i-button type="dashed" size="small" @click="edit(row)">修改</i-button>
      </template>
    </Table>

    <Modal
      v-model="showEdit"
      title="计划添加/修改"
      @on-ok="save"
      @on-cancel="showEdit = false"
    >
      <Form :model="editObj" label-position="left" :label-width="100">
        <FormItem label="Task">
          <i-input type="text" v-model="editObj.task"></i-input>
        </FormItem>
        <FormItem label="DDL">
          <i-input type="number" v-model="editObj.ddl"></i-input>
        </FormItem>
      </Form>
    </Modal>

    <Modal
      v-model="showEditArticle"
      title="读后感"
      @on-ok="saveArticle"
      @on-cancel="showEditArticle = false"
    >
      <Form :model="editArticleObj" label-position="top">
        <FormItem label="读后感">
          <i-input
            type="textarea"
            :rows="20"
            v-model="editArticleObj.article.value"
          ></i-input>
          <span
            style="display: inline-block; margin-right: 40px"
            v-if="editArticleObj.article.updateTime"
            >创建于：{{
              $moment(editArticleObj.article.updateTime).format("MM-DD HH:mm")
            }}</span
          >
          <span
            style="display: inline-block; margin-right: 40px"
            v-if="editArticleObj.article.createTime"
            >修改于：{{
              $moment(editArticleObj.article.createTime).format("MM-DD HH:mm")
            }}</span
          >
        </FormItem>
      </Form>
    </Modal>

    <Modal
      v-model="showEditComment"
      title="老师点评"
      @on-ok="saveComment"
      @on-cancel="showEditComment = false"
    >
      <Form :model="editCommentObj" label-position="top">
        <FormItem label="读后感">
          <i-input
            type="textarea"
            :rows="20"
            v-model="editCommentObj.comment.value"
          ></i-input>
          <span
            style="display: inline-block; margin-right: 40px"
            v-if="editCommentObj.comment.updateTime"
            >创建于：{{
              $moment(editCommentObj.comment.updateTime).format("MM-DD HH:mm")
            }}</span
          >
          <span
            style="display: inline-block; margin-right: 40px"
            v-if="editCommentObj.comment.createTime"
            >修改于：{{
              $moment(editCommentObj.comment.createTime).format("MM-DD HH:mm")
            }}</span
          >
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      planData: {},
      historyData: {},
      col1: [
        {
          title: "No.",
          slot: "number",
          align: "center",
        },
        {
          title: "Task",
          key: "task",
          align: "center",
        },
        {
          title: "DDL",
          key: "ddl",
          align: "center",
        },
        {
          title: "读后感",
          slot: "article",
          align: "center",
        },
        {
          title: "老师点评",
          slot: "comment",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],

      showEdit: false,
      editObj: {
        article: {},
      },

      showEditArticle: false,
      editArticleObj: {
        article: {},
      },
      showEditComment: false,
      editCommentObj: {
        comment: {},
      },
    };
  },
  methods: {
    async getPlanData(page = 1) {
      let res = await this.api({
        url: "/read/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
          isPast: 0,
        },
      });
      res.list = res.list.map((item) => {
        if (!item.article) {
          item.article = {};
        }
        if (!item.comment) {
          item.comment = {};
        }
        return item;
      });

      this.planData = res;
    },
    async getHistoryData(page = 1) {
      let res = await this.api({
        url: "/read/select",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
          page: page,
          size: 10,
          isPast: 1,
        },
      });

      res.list = res.list.map((item) => {
        if (!item.article) {
          item.article = {};
        }
        if (!item.comment) {
          item.comment = {};
        }
        return item;
      });

      this.historyData = res;
    },

    edit(val) {
      this.editObj = val;
      this.showEdit = true;
    },
    async save() {
      await this.api({
        url: "/read/save",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          ...this.editObj,
          student_id: this.$store.getters.selectedStudent._id,
        },
      });
      this.$Message.success("更新成功");
      this.showEditPlan = false;
      this.getPlanData();
      this.getHistoryData();
    },

    editHistory(val) {
      this.editHistoryObj = val;
      this.showEditHistory = true;
    },

    async setHistory(val) {
      await this.api({
        url: "/read/setHistory",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          _id: val._id,
        },
      });

      this.$Message.success("更新成功");
      this.getPlanData();
      this.getHistoryData();
    },

    editArticle(val) {
      this.editArticleObj = val;
      this.showEditArticle = true;
    },
    async saveArticle() {
      await this.api({
        url: "/read/saveArticle",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          ...this.editArticleObj,
          article: this.editArticleObj.article.value,
        },
      });
      this.$Message.success("更新成功");
      this.showEditPlan = false;
      this.getPlanData();
      this.getHistoryData();
    },

    editComment(val) {
      this.editCommentObj = val;
      this.showEditComment = true;
    },
    async saveComment() {
      await this.api({
        url: "/read/saveComment",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
        },
        data: {
          ...this.editCommentObj,
          comment: this.editCommentObj.comment.value,
        },
      });
      this.$Message.success("更新成功");
      this.showEditPlan = false;
      this.getPlanData();
      this.getHistoryData();
    },
  },
  mounted() {
    if (!this.$store.getters.selectedStudent._id) {
      return;
    }
    this.getPlanData();
    this.getHistoryData();
  },

  watch: {
    "$store.getters.selectedStudent": function () {
      this.getPlanData();
      this.getHistoryData();
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  margin-top: 10px;
}

.add-btn {
  margin-top: 10px;
}
</style>